import { SET_MESSAGE_DIALOG } from './types';

export function setMessageDialog(Data) {
    return {
        type: SET_MESSAGE_DIALOG,
        Data,
    };
}
